import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class TriggerService {
  constructor() {
    this.endpoints = createPrefix('/trigger', {
      event: (id) => `/match/${id}`,
      categories: '/categories',
      subCategories: '/sub_categories',
      conditions: '/conditions',
    })
  }

  static create() {
    return new TriggerService()
  }

  async queryEventTriggers(eventId, params) {
    const servicePath = this.endpoints.event(eventId)
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async queryCategories(params) {
    const servicePath = this.endpoints.categories()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async querySubcategories(params) {
    const servicePath = this.endpoints.subCategories()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async queryConditions(params) {
    const servicePath = this.endpoints.conditions()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
